import React from 'react'
import Sidebar from '../Sidebar'
import './index.scss'

const StripeSidebar = ({ config }) => {
  return (
    <div className='sidebar-section'>
      <Sidebar config={config} />
    </div>
  )
}

export default StripeSidebar
